import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';


import Publicas from './modules/publicas';

import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Program from '../../components/Program';
import Youtube from '../../components/Youtube';
import Speakers from '../Speakers';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {



  return (
    <>
      <Capa>
        <div className="p50" style={{marginTop: '30px'}}>

          <img src="/assets/logo.png" style={{width: '100%', maxWidth: '600px'}}/>
          <h2 style={{ margin: '0px auto', marginTop: '20px', color: '#fff', fontSize: '24px'}}>02 de fevereiro às 15h</h2>
          <p style={{marginBottom: '20px'}}>Evento online | Faça sua inscrição</p>
          <div
            className=""
            style={{
              width: '100%',

              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            {' '}

            <Link className="" to="/inscricao">
              <Button type="button">Inscreva-se</Button>
{' '}
            </Link>

            <Link className="" to="/login">
              <Button type="button">Acesse</Button>
{' '}
            </Link>
         
         
          </div>
        
        
        </div>

        <div  style={{maxWidth: '500px'}}>
          <h1 style={{textAlign: 'left'}}>Seminário + Brasil</h1><br/>
          <p style={{maxWidth: '500px', textAlign: 'justify'}}>
          Tão logo ficou sabendo da iniciativa do governo de implantar plenamente, a partir do início desse ano, um novo sistema eletrônico de gestão de convênios para recursos federais - Plataforma + Brasil - que abrangera os destinados a ciência e tecnologia, o Confies procurou os ministério da economia, educação, ciência e tecnologia e a CGU para difundir rapidamente as novas regras a sua comunidade de fundações por meio desse Seminário. <br/><br/>
A ideia foi muito bem recebida pelos parceiros representantes dos ministérios aos quais agradecemos.<br/><br/>
Esperamos que seja útil pois s participação dos usuários é essencial  para o sucesso da plataforma.
          </p>
        </div>

     
      </Capa>
      <Capa id="palestrantes">
        <Speakers/>
      </Capa>

      <SponsorsList/>
    </>
  );
};
export default Home;
